<template>
  <b-container class="login-wrapper h-100" fluid>
    <b-row class="h-100">
      <b-col
        class="login-wrapper--left w-50 vh-100 d-none d-sm-none d-md-block"
      >
        <b-row class="h-100">
          <b-img
            center
            src="/img/login.svg"
            alt="Login Image"
            class="jumbotron-img"
          />
          <div class="mt-4 justify-content-center mx-auto">
            <h2 class="page-title my-0">
              Find all your trade passes in one place.
            </h2>
            <p class="mt-3 text-center grey--text">
              No more paper trails and bulky folders.
            </p>
          </div>
        </b-row>
      </b-col>
      <b-col class="login-wrapper--right w-50 vh-100">
        <slot name="form"></slot>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'MainAuthLayout',

  computed: {
    ...mapState({
      isAuthenticated: state => state.auth.isAuthenticated,
      user: state => state.auth.user
    })
  },

  async mounted() {
    if (!this.isAuthenticated) {
    } else {
      this.$router.replace({ name: 'home.welcome-page' })
    }
  }
}
</script>
